// import '@fortawesome/fontawesome-pro/css/all.css'
import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const opts = {
  theme: {
    light: true,
    themes: {
      light: {
        primary: '#B71C1C',
        secondary: '#E8EAF6',
        accent: '#455A64',
        error: '#F44336',
        vermelho_corpore: '#BD2730',
      },
    },
  },
  icons: {
    iconfont: 'fa',
  },
}

export default new Vuetify(opts)